import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import 'antd/dist/reset.css';
import './assets/style/index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Provider } from 'react-redux';
import configureStore from './js/store';
import Internationalization from './src-new/providers/InternationalizationProvider';
import { MantineProvider } from '@mantine/core';
import GlobalInternalizationProvider from './src-new/providers/GlobalInternalizationProvider';
import ErrorBoundary from './components/UI/organisms/ErrorBoundary/ErrorBoundary';
import { interceptConsole } from './logging/consoleInterceptor';

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

window.store = store;
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: `${window.location.origin}/signin`,
          audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`,
          prompt: 'login',
        }}
      >
        <MantineProvider defaultColorScheme="light">
          <Internationalization>
            <GlobalInternalizationProvider>
              <App />
            </GlobalInternalizationProvider>
          </Internationalization>
        </MantineProvider>
      </Auth0Provider>
    </Provider>
  </ErrorBoundary>,
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('./firebase-messaging-sw.js', {
      scope: './firebase-cloud-messaging-push-scope',
    })
    .then((registration) => {
      // Service worker registration was successful
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      // Service worker registration failed
      console.error('Service Worker registration failed:', error);
    });
}

interceptConsole();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
